import React, { useRef, useEffect } from 'react'
import styles from './styles.module.css'
import { colors } from '../../../../themes/colors'

// component function
export default function ScoreCardBestAssets(props) {

	const { type, scores, label, fullImage, bestObject, video } = props
	const canvasRef = useRef()
	const ctxRef = useRef()
	const maxWidth = 362
	const maxHeight = 445
	const videoRatio = video ? video.width / (video.height * (1/video.streamInfo.pixelAspectRatio)) : 1.78
	const videoWidth = videoRatio < 1 ? maxHeight * videoRatio : maxWidth
	const videoHeight = videoRatio < 1 ? maxHeight : videoWidth * 1/videoRatio
	const canvasWidth = videoWidth * window.devicePixelRatio
	const canvasHeight = videoHeight * window.devicePixelRatio
	const brandScoreTotal = Math.round(video?.scoreCueTypeCategoryAttention[1])
	const commsScoreTotal = Math.round(video?.scoreCueTypeCategoryAttention[2])
	const brandScoreAsset = Math.round(scores.brand*10)/10 > brandScoreTotal ? brandScoreTotal : Math.round(scores.brand*10)/10
	const commsScoreAsset = Math.round(scores.comms*10)/10 > commsScoreTotal ? commsScoreTotal : Math.round(scores.comms*10)/10
	const brandScorePct = brandScoreTotal > 0 ? Math.round(brandScoreAsset/brandScoreTotal * 100) : 0
	const commsScorePct = commsScoreTotal > 0 ? Math.round(commsScoreAsset/commsScoreTotal * 100) : 0

	// dynamic styles
	const canvasWrapStyle = {
		maxWidth: videoWidth
	}

	const objectStyle = {
		left: 'calc(' + bestObject.x * 100 + '% - 1px',
		top: 'calc(' + bestObject.y * 100 + '% - 1px',
		width: 'calc(' + bestObject.w * 100 + '% + 2px',
		height: 'calc(' + bestObject.h * 100 + '% + 2px',
		border: '2px solid ' + (type === 'brand' ? colors.brand : colors.comms)
	}

	// context- & canvas refs & other inits on mount
	useEffect(() => {
		ctxRef.current = canvasRef.current.getContext('2d')
		ctxRef.current.imageSmoothingEnabled = false
		const img = new Image()
		img.onload = () => ctxRef.current.drawImage(img,0,0, canvasWidth, canvasHeight)
		img.src = fullImage
		// eslint-disable-next-line react-hooks/exhaustive-deps
	},[fullImage])

	const brandScore = (scores.brand !== undefined && scores.brand > -1 ?
		<div className={styles.scoreWrapper}>
			<div className={styles.scoreBox + ' ' + styles.colorBrand}>{brandScorePct}%</div>
			<div className={styles.scoreLabel}>of total Brand Attention</div>
		</div>
		: scores.brand === -1 ?
		<div className={styles.scoreWrapper + ' ' + styles.noAsset}>
			<div className={styles.scoreLabel}>n/a</div>
		</div>
		: null
	)

	const commsScore = (scores.comms !== undefined && scores.comms > -1 ?
		<div className={styles.scoreWrapper}>
			<div className={styles.scoreBox + ' ' + styles.colorComms}>{commsScorePct}%</div>
			<div className={styles.scoreLabel}>of total Messaging Attention</div>
		</div>
		: scores.comms === -1 ?
		<div className={styles.scoreWrapper + ' ' + styles.noAsset}>
			<div className={styles.scoreLabel}>n/a</div>
		</div>
		: null
	)

	const assetLabel = label && <div className={styles.assetLabel}>{label}</div>

	const assetImage = (
		<div style={canvasWrapStyle} className={styles.canvasWrap}>
			<canvas className={styles.canvas} ref={canvasRef} width={canvasWidth} height={canvasHeight} />
			<div style={objectStyle} className={styles.bestObject} />
		</div>
	)

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.contentWrapper}>
					{brandScore}
					{commsScore}
					{assetLabel}
					{assetImage}
				</div>
			</div>
		</>
	)
}
